module.exports = __webpack_public_path__ + "img/LeftButtonNormal.7197b48f.webp";